export var typography = {
    fontSize: 14,
    htmlFontSize: 16,
    fontFamily: 'Inter, sans-serif',
    fontWeightBold: 700,
    h1: {
        fontWeight: 600,
        fontSize: '1.5625rem',
    },
    h2: {
        fontWeight: 600,
        fontSize: '1.375rem',
    },
    h3: {
        fontWeight: 600,
        fontSize: '1.125rem',
    },
    h4: {
        fontWeight: 600,
        fontSize: '1rem',
    },
    h5: {
        fontWeight: 600,
        fontSize: '0.9375rem',
    },
    h6: {
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    subtitle1: {
        fontWeight: 300,
        fontSize: '1.375rem',
    },
    subtitle2: {
        fontWeight: 300,
        fontSize: '1rem',
    },
    body1: {
        fontSize: '0.875rem',
    },
    body2: {
        fontSize: '0.775rem',
    },
    button: {
        fontWeight: 500,
        textTransform: 'none',
        fontSize: '0.875rem',
    },
    caption: {
        fontSize: '0.65625rem',
        textTransform: 'none',
    },
};
